import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 's3Filename',
  standalone: false
})
export class S3FilenamePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      const split = value.split('/');
      return split.length > 0 ? split[split.length - 1] : '';
    }
  }
}
